import * as React from "react";

// Figma vrstva `play-button` (uzel 13207:42280) — žluté plné tlačítko na miniatuře
// sbalené karty masterclass (13207:42375). Dvoubarevná ilustrace, ne obrysová ikona
// jako `IconPlayCircle`, proto vlastní komponenta místo úpravy sdílené. [TD-327 S-02]
function IconPlayButton(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M32.8862 6.85867H9.11388C4.4498 6.85867 0.668819 10.6397 0.668819 15.3037V27.1874C0.668819 31.8514 4.4498 35.6324 9.11388 35.6324H32.8862C37.5502 35.6324 41.3312 31.8514 41.3312 27.1874V15.3037C41.3312 10.6397 37.5502 6.85867 32.8862 6.85867ZM27.8622 21.8237L16.7431 27.1269C16.4469 27.2682 16.1046 27.0521 16.1046 26.7239V15.7862C16.1046 15.4533 16.4558 15.2376 16.7527 15.3881L27.8718 21.0227C28.2024 21.1902 28.1967 21.6643 27.8622 21.8237Z"
        fill="#FDC32F"
      />
      <path
        d="M27.8622 21.8237L16.7431 27.1269C16.4468 27.2682 16.1046 27.0522 16.1046 26.7239V15.7862C16.1046 15.4533 16.4558 15.2376 16.7527 15.3881L27.8718 21.0227C28.2024 21.1902 28.1967 21.6643 27.8622 21.8237Z"
        fill="#474539"
      />
    </svg>
  );
}

export default IconPlayButton;
